import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
import { AuthService } from 'app/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class RawdataFinderService {

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { }

  getInstitutos() {
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.ods.getInstituteArray);
  }

  getRawDatas(datos:any){
    let anio = datos.anio;
    let broker = datos.broker != null ? datos.broker : localStorage.getItem('instituto_id');
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getRawDatas + datos.broker + '/' + anio );
  }
}
